import { useTranslation } from "react-i18next";

import { I18N_PUBLIC_NAMESPACE } from "@ryde/shared";

export const useRtl = () => {
  const { i18n } = useTranslation(I18N_PUBLIC_NAMESPACE, {
    useSuspense: false,
  });
  const direction = i18n.dir();
  const isRtl = direction === "rtl";
  return { direction, isRtl };
};
